import { StorageKeys } from 'src/app/shared-module-files/simpo.constant';

/** Use the beeOs sign-in credential, never a Passbook integration token. */
export function crmBearerCredential(): string | null {
  let token: string;
  try { token = (localStorage.getItem(StorageKeys.token) || '').trim(); }
  catch { return null; }
  token = token.replace(/^Bearer\s+/i, '').trim();
  if (!token || /^(null|undefined|bearer)$/i.test(token) || /\s/.test(token)) return null;
  return `Bearer ${token}`;
}
